import React, { useEffect } from "react";
import { JssProvider } from "react-jss";
import classNames from "classnames";
import {
  ThemeProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import defaultTheme from "./themes";
//import PageRoutes from "./router/PageRoutes";
import ViewRoutes from "./router/ViewRoutes";
import { AppStyles } from "./themes/AppStyles";
import Header from "./navigation/Header";
import LeftDrawer from "./navigation/SideNavBar";
import NavBarData from "./common/data/Navbardata";
//-----
import GlobalContext from "./common/contexts/GlobalContext";
import Login from "./components/Login";
import { AuthProvider, msalConfig } from "./components/Authentication";

import { default as Apiservices } from "./common";
//-----
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: false,
});


export default function App() {
  const [state, setState] = React.useState({
    theme: defaultTheme.default,
    rightDrawerOpen: false,
    navDrawerOpen:
      window &&
        window.innerWidth &&
        window.innerWidth >= defaultTheme.default.breakpoints.values.md
        ? false
        : true,
  });
  const [hideSubmenus, setHideSubmenus] = React.useState(false);
  const [spinner, setSpinner] = React.useState(true);
  const [sideMenuCreateJob,setSideMenuCreateJob] = React.useState(false);
  useEffect(() => {
    console.log("gfd------------", state);
    if (state.navDrawerOpen) {
      setHideSubmenus(true);
    } else {
      setHideSubmenus(false);
    }
  }, [state]);
  const [masterDataObj, setMasterDataObj] = React.useState([]);
  const [login, setLogin] = React.useState("home");
  const { instance, accounts } = useMsal();

  const onLoginChange = (type) => {
    setLogin(type);
  };

 
  const Logout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/chail",
    });
    sessionStorage.removeItem('menuActiveColor');
  };

  function handleChangeNavDrawer() {
    setState({
      navDrawerOpen: !state.navDrawerOpen,
    });
  }
  useEffect(() => {
    if (accounts?.length > 0) {
      sessionStorage.setItem('user_email', accounts[0].username)
      sessionStorage.setItem('user_name', accounts[0].name)
      if(!sessionStorage.getItem('token')){
        getUserAuth(accounts[0].username);
      }
      console.log("user accounts", accounts)
    }
  }, [accounts]);

  const classes = AppStyles();
  const { navDrawerOpen } = state;

  const getUserAuth = async (user_email) => {
    // let userName = "msr@tmilltd.com"
    let userCredentials = { "user_email": user_email }
    const TokenResponse = await Apiservices.getUserToken(userCredentials)
    console.log(TokenResponse, "tokenResponse")
    if (TokenResponse && TokenResponse.issuccess === 1) {
      sessionStorage.setItem('token', TokenResponse.token);
      setSpinner(false)
    }
  }
  useEffect(() => {
    setTimeout(() => { if (accounts?.length == 0) { setSpinner(false) } }, 1000);
  }, []);
  return (
    !spinner && (
      <>
        {/* {accounts[0] ? ( */}
          <>
            <div>
              {/* {login === "user" ? ( */}
              <JssProvider generateClassName={generateClassName}>
                <ThemeProvider theme={defaultTheme.default}>
                  <Header
                    handleChangeNavDrawer={handleChangeNavDrawer}
                    // navDrawerOpen={navDrawerOpen}
                    logout={Logout}
                  />

                  {/* <LeftDrawer
                    navDrawerOpen={navDrawerOpen}
                    handleChangeNavDrawer={handleChangeNavDrawer}
                    menus={NavBarData.menus}
                    hideSubmenus={hideSubmenus}
                  /> */}
                  <div
                    className={classNames(
                      classes.container,
                      !navDrawerOpen && classes.containerFull
                    )}
                  >
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        {/* <PageRoutes /> */}
                        <ViewRoutes />
                      </MuiPickersUtilsProvider>
                  </div>
                </ThemeProvider>
              </JssProvider>
              {/* ) : (
        <div>
          <Login onLoginChange={onLoginChange} />
        </div>
      )} */}
            </div>
          </>
        {/* ) : (
          <div >
            <Login onLoginChange={onLoginChange} />
          </div>
        )} */}
      </>
    )
  );
}
